import Cookies from "js-cookie";

export const getUserMail = () => {
    try {
        const userMail:any = Cookies.get('details');
        const {email}=JSON.parse(userMail);
        return email
    } catch (error) {
        console.error("Error parsing or retrieving cookie:", error);
    }
 }